export const operatorChoices = [
    { id: 'Zwrotka', name: 'Zwrotka' },
    { id: 'ZwrotkaTest', name: 'Zwrotka Test' },
    { id: 'Kaucja', name: 'Kaucja' },
    { id: 'PSK', name: 'PSK' },
    { id: 'Reselekt', name: 'Reselekt' },
];
